module.exports = __webpack_public_path__ + "img/terroir-wavy-2-mobile.b20a1b6f.jpg";